export const isProduction = () => {
  return process.env.NODE_ENV === 'production';
};

export const SB_API_URL = isProduction()
  ? (window as any).environment?.hq
  : process.env.SB_API_URL;

export const CCBE_API_URL = () =>
  isProduction()
    ? (window as any).environment?.urls?.ccBeApi
    : process.env.CCBE_API_URL;

export const getAssetUrl = (path: string) => {
  const baseUrl = (window.environment?.urls?.assetUrl ?? '').replace(/\/$/, '');

  return `${baseUrl}${path}`;
};
